import { MAPBOX_ACCESS_TOKEN } from '~/config';
import mapboxGeocoder from '@mapbox/mapbox-sdk/services/geocoding';
import { MapiResponse } from '@mapbox/mapbox-sdk/lib/classes/mapi-response';

export const getGeolocation = (
  zipCode: string,
  countryCode: string
): Promise<MapiResponse> =>
  mapboxGeocoder({ accessToken: MAPBOX_ACCESS_TOKEN })
    ?.forwardGeocode({
      query: zipCode,
      countries: [countryCode],
      types: ['postcode'],
      autocomplete: false,
      mode: 'mapbox.places',
    })
    .send();
